<template>
  <div class="container-fluid">
    <b-card class="mt-3 mb-1">
      <b-card-header class="p-0"
        ><b-card-body class="px-0 py-1">
          <b-row>
            <b-col xl="5" lg="4" md="3">
              <b-card-title class="card-title-doorder my-1"
                >New Order</b-card-title
              ></b-col
            >
            <b-col xl="7" lg="8" md="3">
              <!-- <a id="importButton"
											class=" btn-doorder-filter btn-doorder-filter-grey w-100"
											>Upload mass
											order</a> -->
              <router-link
                to="/doorder/upload_orders"
                id=""
                class="
                  btn btn-bumblebee btn-doorder btn-add btn-doorder-secondary
                  m-0
                  float-right
                "
              >
                Upload mass order
              </router-link>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card-header>
    </b-card>

    <b-form @submit.prevent="onSubmit" ref="addOrderForm">
      <b-card no-body class="card-transparent-background">
        <b-card-body class="p-0">
          <CustomerDetails
            type="add"
            :first_name.sync="first_name"
            :last_name.sync="last_name"
            :email.sync="email"
            :contact_number.sync="contact_number"
            :invalid_contact_number="invalid_contact_number"
            :dropoff_address.sync="dropoff_address"
            :invalid_dropoff_address="invalid_dropoff_address"
            :dropoff_latitude.sync="dropoff_latitude"
            :dropoff_longitude.sync="dropoff_longitude"
            :dropoff_eircode.sync="dropoff_eircode"
            :invalid_dropoff_eircode="invalid_dropoff_eircode"
            :invalid_dropoff_latitude="invalid_dropoff_latitude"
            :invalid_dropoff_longitude="invalid_dropoff_longitude"
          />

          <PackageDetails
            type="add"
            :pickup_address.sync="pickup_address"
            :pickup_latitude.sync="pickup_latitude"
            :pickup_longitude.sync="pickup_longitude"
            :pickup_addresses="pickup_addresses"
            :invalid_pickup_address="invalid_pickup_address"
            :fulfilment_date.sync="fulfilment_date"
            :invalid_fulfilment_date="invalid_fulfilment_date"
            :package_weight.sync="package_weight"
            :package_weight_list="package_weight_list"
            :invalid_package_weight="invalid_package_weight"
            :package_size.sync="package_size"
            :package_size_list="package_size_list"
            :invalid_package_size="invalid_package_size"
            :number_packages.sync="number_packages"
            :deliver_by.sync="deliver_by"
            :deliver_by_list="deliver_by_list"
            :invalid_deliver_by="invalid_deliver_by"
            :other_details.sync="other_details"
            :is_fragile.sync="is_fragile"
          />
        </b-card-body>
      </b-card>
      <input type="hidden" name="client" v-model="client_name" />
      <b-row class="my-4">
        <b-col lg="4" md="6" class="mx-auto">
          <b-button
            type="submit"
            variant="doorder-primary"
            class="btn btn-bumblebee btn-doorder btn-submit-register mx-auto"
            v-if="!is_loading"
            >Submit</b-button
          >
          <b-button
            type="button"
            disabled
            variant="doorder-primary"
            class="btn btn-bumblebee btn-doorder btn-submit-register mx-auto"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from "axios";
import CustomerDetails from "./order_details_components/CustomerDetails.vue";
import PackageDetails from "./order_details_components/PackageDetails.vue";

export default {
  name: "DoOrderAddOrder",
  components: { CustomerDetails, PackageDetails },
  data() {
    return {
      client_name: "DOORDER",
      type: "retailer",
      retailer_id: null,
      user_title: null,

      //customer details
      first_name: null,
      last_name: null,
      email: null,
      contact_number: null,
      invalid_contact_number: false,
      dropoff_address: null,
      invalid_dropoff_address: false,
      dropoff_eircode: null,
      invalid_dropoff_eircode: false,
      dropoff_latitude: "",
      invalid_dropoff_latitude: false,
      dropoff_longitude: "",
      invalid_dropoff_longitude: false,

      pickup_address: null,
      pickup_address_str: null,
      pickup_latitude: null,
      pickup_longitude: null,
      pickup_addresses: [],
      invalid_pickup_address: false,
      fulfilment_date: null,
      invalid_fulfilment_date: false,
      package_weight: null,
      package_weight_list: [],
      invalid_package_weight: false,
      package_size: null,
      package_size_list: [],
      invalid_package_size: false,
      number_packages: null,
      deliver_by: null,
      deliver_by_list: [],
      invalid_deliver_by: null,
      other_details: null,
      is_fragile: false,

      is_loading: false,
    };
  },
  updated() {},
  watch: {
    pickup_address(newVal, oldVal) {
      console.log("in watch address", newVal, oldVal);
      let selected_location = null;
      for (let i = 0; i < this.pickup_addresses.length; i++) {
        if (this.pickup_addresses[i].id == newVal) {
          selected_location = this.pickup_addresses[i];
          this.pickup_address_str = selected_location.address;
          this.pickup_longitude = selected_location.longitude;
          this.pickup_latitude = selected_location.latitude;
        }
      }
    },
  },
  mounted() {
    console.log("in add order mounted");
    console.log(process.env);
    console.log(process.env.MAP_COUNTRIES);
    
    let user = JSON.parse(window.localStorage.getItem("user"));
    console.log(user);
    this.user_id = user.id;
    this.user_title = user.title;
    this.getRetailerViewData(user.id);

    this.pickup_addresses = [{ label: "Dublin", code: 1 }];

    this.package_weight_list = [
      { label: "Very light", code: "Very light" },
      { label: "Light", code: "Light" },
      { label: "Medium", code: "Medium" },
      { label: "Very heavy", code: "Very heavy" },
      { label: "Max 20kg", code: "Max 20kg" },
    ];

    this.package_size_list = [
      { label: "Small bag", code: "Small bag" },
      { label: "Medium bag", code: "Medium bag" },
      { label: "Large bag", code: "Large bag" },
      { label: "Shoe box", code: "Shoe box" },
      { label: "Large box", code: "Large box" },
    ];

    this.deliver_by_list = [
      { label: "Car", code: "car" },
      { label: "Scooter", code: "Scooter" },
      { label: "Bicycle", code: "Bicycle" },
    ];
  },
  methods: {
    getRetailerViewData(retailer_id) {
      axios
        .get("/retailer/profile/" + retailer_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          let retailer = response.data.retailer;
          this.pickup_addresses = retailer.locations;
          // this.retailer.qr_scan_required =
          //   this.retailer.qr_scan_required == 1 ? true : false;

          // this.events = response.data;
          //   this.setEventData(response.data);
        });
    },

    async onSubmit() {
      console.log("submit add order");
      console.log(this.first_name, this.last_name);
      console.log(this.email, this.contact_number);
      console.log(this.dropoff_address, this.dropoff_eircode);
      console.log(this.dropoff_longitude, this.dropoff_latitude);
      console.log("----- package details");
      console.log(
        this.pickup_address,
        this.pickup_latitude,
        this.pickup_longitude,
        this.pickup_address_str
      );
      console.log(this.fulfilment_date);
      console.log(this.package_weight, this.package_size);
      console.log(this.number_packages, this.deliver_by);
      console.log(this.other_details, this.is_fragile);

      // check validation
      // customer details
      if (this.contact_number == "" || this.contact_number == null) {
        this.invalid_contact_number = true;
      } else {
        this.invalid_contact_number = false;
      }
      if (this.dropoff_address == null || this.dropoff_address == "") {
        this.invalid_dropoff_address = true;
      } else {
        this.invalid_dropoff_address = false;
      }
      if (this.dropoff_eircode == null || this.dropoff_eircode == "") {
        this.invalid_dropoff_eircode = true;
      } else {
        this.invalid_dropoff_eircode = false;
      }
      if (this.dropoff_latitude == null || this.dropoff_latitude == "") {
        this.invalid_dropoff_latitude = true;
      } else {
        this.invalid_dropoff_latitude = false;
      }

      if (this.dropoff_longitude == null || this.dropoff_longitude == "") {
        this.invalid_dropoff_longitude = true;
      } else {
        this.invalid_dropoff_longitude = false;
      }

      // validate package details
      if (this.pickup_address == null || this.pickup_address == "") {
        this.invalid_pickup_address = true;
      } else {
        this.invalid_pickup_address = false;
      }
      if (this.fulfilment_date == null || this.fulfilment_date == "") {
        this.invalid_fulfilment_date = true;
      } else {
        this.invalid_fulfilment_date = false;
      }
      if (this.package_weight == null || this.package_weight == "") {
        this.invalid_package_weight = true;
      } else {
        this.invalid_package_weight = false;
      }
      if (this.package_size == null || this.package_size == "") {
        this.invalid_package_size = true;
      } else {
        this.invalid_package_size = false;
      }
      if (this.deliver_by == null || this.deliver_by == "") {
        this.invalid_deliver_by = true;
      } else {
        this.invalid_deliver_by = false;
      }

      if (
        this.invalid_contact_number ||
        this.invalid_dropoff_address ||
        this.invalid_dropoff_eircode ||
        this.invalid_dropoff_latitude ||
        this.invalid_dropoff_longitude ||
        this.invalid_pickup_address ||
        this.invalid_fulfilment_date ||
        this.invalid_package_weight ||
        this.invalid_package_size ||
        this.invalid_deliver_by
      ) {
        console.log("invalid data :(");
      } else {
        console.log("validated data :D");
        this.sendAddOrderRequest();
      }
    },
    sendAddOrderRequest() {
      console.log("in send add order request", this.client_name);
      let requestData = {
        client: this.client_name,
        owner_id: this.user_id,
        owner_type: "Retailer",
        contact: {
          name: this.first_name + " " + this.last_name,
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.contact_number,
          email: this.email,
        },

        post_code: this.dropoff_eircode,
        location: this.dropoff_address,
        location_lat: this.dropoff_latitude,
        location_lang: this.dropoff_longitude,

        pickup: this.pickup_address_str,
        pickup_lat: this.pickup_latitude,
        pickup_lang: this.pickup_longitude,

        order_details: {
          fulfilment_date: this.fulfilment_date,
          weight: this.package_weight,
          dimensions: this.package_size,
          no_of_items: this.number_packages,
          deliver_by: this.deliver_by,
          fragile: this.is_fragile,
        },
        description: this.other_details,
      };
      console.log(requestData);
      axios
        .post("jobs/jobs", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Order is created successfully ",
            type: "success",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          // this.$refs.retailerRegisterForm.reset();
          // this.locations = [
          //   {
          //     address: "",
          //     post_code: "",
          //     latitude: "",
          //     longitude: "",
          //     country: "",
          //     county: "",
          //     business_hours: "",
          //     business_hours_json: "",
          //   },
          // ];
          // this.contacts = [{ name: "", phone: "", email: "", location: null }];
          this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              container: "swal-alert-doorder",
              confirmButton:
                "btn btn-bumblebee btn-doorder btn-doorder-primary btn-doorder-submit",
              cancelButton:
                "btn btn-bumblebee btn-doorder btn-doorder-danger-outline btn-doorder-submit",
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/doorder/orders/AddOrder.vue